import {defineStore} from 'pinia'
import {trim} from '@/util/Util'
import apiURL from '@/bis/data/loginAuthApi.json'
import {ResponseErrorCode, Roles, StorageKeys} from '@/bis/data/constants'

const SERVER_URL = process.env.VUE_APP_BASE_URL;

export const useLoginAuth = (router) => {
    const initStore = (store) => {
        store.saveIdYn = localStorage.getItem(StorageKeys.SAVE_USER_ID_YN) || false
        store.accessToken = localStorage.getItem(StorageKeys.ACCESS_TOKEN) || ''
    }
    const createLoginAuthStore = defineStore('LoginAuthStore', {
        // 브라우저 refresh 하면 state 는 지워짐
        // accessToken 만 보관
        state: () => ({
            saveIdYn: false,
            error: {message: '',userId: '', password: ''},
            accessToken: '',
            _loginUser: null
        }),

        getters: {
            currentUser() {
                // if(this._loginUser == null) {
                //     const stored = localStorage.getItem(StorageKeys.CURRENT_USER)
                //     this._loginUser = stored? JSON.parse(stored) : null
                // }
                return this._loginUser || {}
            },
            userLoggedIn() {
                if (this.accessToken == null || this.accessToken == '') {
                    // console.log(localStorage.getItem(StorageKeys.ACCESS_TOKEN))

                    this.accessToken = localStorage.getItem(StorageKeys.ACCESS_TOKEN)
                }
                
                return (this.accessToken != null && this.accessToken !== '')
            },
            savedUserId() {
                return this.saveIdYn ? localStorage.getItem(StorageKeys.STORED_USER_ID) : ''
            },
            getAccessToken() {
                return (this.accessToken !== null && this.accessToken !== '')
                    ? this.accessToken
                    : localStorage.getItem(StorageKeys.ACCESS_TOKEN)
            },
            getRouter() {
                return router;
            }
        },

        actions: {
            async authenticate(userId, password) {
                userId = trim(userId)
                password = trim(password)
                if (this.saveIdYn) {
                    localStorage.setItem(StorageKeys.STORED_USER_ID, userId)
                }
                this.error.userId = userId? '' : '아이디를 입력하세요'
                this.error.password = password? '' : '비밀번호를 입력하세요'

                if (!this.error.userId && !this.error.password) {
                    // api 조회 결과를 기다렸다가 진행해야 함
                    // await 필수
                    await fetch(
                        `${SERVER_URL}${apiURL.baseUri}${apiURL.login.api}?userId=${userId}&passwd=${password}`,
                        {
                            method: apiURL.login.method
                        }
                    ).then(res => res.json())
                    .then(res => {
                        if (res.success) {
                            let currentUser = res.payload
                            this.accessToken = currentUser.accessToken
                            this._loginUser = currentUser
                            currentUser.roleDesc = Roles[res.payload.roleName]
                            
                            localStorage.setItem(StorageKeys.ACCESS_TOKEN, currentUser.accessToken)

                            if (currentUser.roleName === 'ROLE_ROOT' || currentUser.roleName === 'ROLE_ADMIN') {
                                router.push({name:'orderList'})
                            } else if (currentUser.roleName === 'ROLE_SUPPLIER') {
                                router.push({name:'orderListForSeller'})
                            } else if (currentUser.roleName === 'ROLE_BRANCH') {
                                router.push({name:'orderListForBranch'})
                            }
                            
                            // router.push({name:'orderList'})
                        } else {
                            this.error.message = res.error.msg
                        }
                    })
                    .catch(err => {
                        this.error.message = err.message
                    })
                    .finally(() => {
                        // console.log('LoginAuthStore.refreshUserInfo - finally')
                        // console.log(this._loginUser)
                    })
                }
            },

            async refreshUserInfo() {
                // console.log('LoginAuthStore.refreshUserInfo - start')

                // token 확인
                var storedAccessToken = localStorage.getItem(StorageKeys.ACCESS_TOKEN)

                if (storedAccessToken != null && storedAccessToken !== '') {
                    // api 조회 결과를 기다렸다가 진행해야 함
                    // await 필수
                    await fetch(
                        `${SERVER_URL}${apiURL.baseUri}${apiURL.getInfo.api}`,
                        {
                            method: apiURL.getInfo.method,
                            headers: {'X-AUTH-TOKEN': storedAccessToken}
                        }
                    ).then(res => res.json())
                    .then(res => {
                        if (res.success) {
                            let currentUser = res.payload
                            this.accessToken = currentUser.accessToken
                            this._loginUser = currentUser
                            currentUser.roleDesc = Roles[res.payload.roleName]
                        } else {
                            this.error.message = res.error.msg
                        }
                    })
                    .catch(err => {
                        this.error.message = err.message
                    })
                    .finally(() => {
                        // console.log('LoginAuthStore.refreshUserInfo - finally')
                        // console.log(this._loginUser)
                    })
                }
            },

            async logout () {
                fetch(
                    `${SERVER_URL}${apiURL.baseUri}${apiURL.logout.api}`,
                    {
                        method:apiURL.logout.method,
                        headers: {'X-AUTH-TOKEN': this.accessToken}
                    }
                ).then(res => res.json())
                .then(res => {
                    localStorage.removeItem(StorageKeys.CURRENT_USER)
                    localStorage.removeItem(StorageKeys.ACCESS_TOKEN)

                    this._loginUser = null
                    this.accessToken = ''
                    router.push({name: 'LoginView'})
                    if(res.success) {
                        this.error.message = '';
                    } else {
                        this.error.message = res.payload.msg
                        console.error(res.payload.msg)
                    }
                })
            },

            toggleSaveId () {
                this.saveIdYn = !this.saveIdYn
                localStorage.setItem(StorageKeys.SAVE_USER_ID_YN, this.saveIdYn)
                localStorage.setItem(StorageKeys.STORED_USER_ID, '')
            },

            redirectInvalidSession(res) {
                if((res.error && res.error.code === ResponseErrorCode.INVALID_ACCESS_TOKEN) || res.status === ResponseErrorCode.INVALID_ACCESS_TOKEN) {
                    // console.error('redirectInvalidSession')

                    this.accessToken = ''
                    localStorage.removeItem(StorageKeys.ACCESS_TOKEN)
                    
                    console.log('redirecting login view')
                    router.push({name: 'LoginView'})
                }
            }
            
        }
    })

    const LoginAuthStore = createLoginAuthStore()
    initStore(LoginAuthStore)
    return LoginAuthStore
}
